<template>
  <div>
    <v-toolbar flat class="primary" >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-img height="90px" class="mb-2" contain :src="`${appUrl}/storage/img/logo_columbus.png`" v-on="on" @click="goToHome" style="cursor:pointer"></v-img>
        </template>
        <span>{{ $t('go_home') }}</span>
      </v-tooltip>
    </v-toolbar>
    <v-divider></v-divider>
    <v-list dense v-if="Object.keys(userMenu).length > 0">
      <v-list-group
        v-for="(app, a) in userMenu"
        :key="a"
        :prepend-icon="app.icon"
        :append-icon="app.modules.length !== 0 ? '$vuetify.icons.expand' : ''"
      >
        <v-list-tile :to="app.route" slot="activator">
          <v-list-tile-title v-text="$t(app.name)"></v-list-tile-title>
        </v-list-tile>

        <div v-for="(mod, m) in app.modules" :key="m">
          <v-list-group           
            v-if="Object.keys(mod.functions).length > 0"
            :no-action="true"
            sub-group
            value="true"
          >
            <v-list-tile :to="mod.route" slot="activator">
              <v-list-tile-title v-text="$t(mod.name)"></v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              v-for="(func, f) in mod.functions"
              :key="f"
              :to="func.route"
            >
              <v-list-tile-title>
                <v-icon class="mr-2">{{ func.icon ? func.icon : 'play_circle_outline' }}</v-icon> {{ $t(func.name) }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :to="mod.route" slot="activator" class="ml-4" :prepend-icon="mod.icon ? mod.icon : 'play_circle_outline'">
            <v-list-tile-title>
                <v-icon class="mr-2" > {{ mod.icon ? mod.icon : 'play_circle_outline' }}</v-icon> {{ mod.name }}
            </v-list-tile-title>
          </v-list-tile>
        </div>
      </v-list-group>
    </v-list>
    <div v-else class="pa-3 grey--text text-md-center">
      <v-progress-circular
        :size="50"
        color="grey lighten-3"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      appUrl: window.config.appUrl,
      name: this.$t('nav_menu_title'),
      items: [
        { title: 'list_name', icon: 'list', route: { name: 'route_name' } }
      ]
    }
  },
  computed: mapGetters([
    'userMenu'
  ]),
  methods: {
    goToHome() {
      return this.$router.push({name: 'home'});
    }
  }
}
</script>

<style scoped>
  .v-list__tile__title {
    font-size: 14px;
  }
  .v-list__group__header__prepend-icon {
    margin-right: -10px;
  }

  .v-list__tile__action:hover .v-icon {
    text-decoration: none;
    text-decoration-line: none !important;
  }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/NavMenu.vue